




































import Vue from 'vue';
import { FileSystemState } from '@/files';
import { TFile, TDirectory } from '@/files/types';

export default Vue.extend({
  name: "files",
  props: {
    forceShow: Boolean,
    hideFiles: Boolean,
    preventDefaultFile: Boolean,
    preventDefaultDirectory: Boolean,
    selectedFile: Object
  },
  data() {
    return {
      showFiles: false,
    };
  },
  computed: {
    currentDirectory: FileSystemState.currentDirectory,
    currentFile: FileSystemState.currentFile,
    isRoot: function (): boolean {
      return this.currentDirectory === FileSystemState.filesystem()
    },

    files: function (): TFile[] {
      return this.currentDirectory.files
        .slice()
        .sort();
    },

    directories: function (): TDirectory[] {
      return this.currentDirectory.directories
        .slice()
        .sort();
    }
  },
  methods: {
    openDirectory: function (directory: TDirectory) {
      if (this.preventDefaultDirectory) {
        this.$emit('open:directory', directory);
        return;
      }

      FileSystemState.openDirectory(directory);
    },

    openFile: function (file: TFile) {
      if (this.preventDefaultFile) {
        this.$emit('open:file', file);
        return;
      }

      FileSystemState.openFile(file);
    },

    close: function () {
      this.showFiles = false;
    }
  },
  watch: {
    currentFile: function (value) {
      this.$emit('open', value);
    }
  }
})
